import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

import { MaterialModule } from 'src/app/shared/material.module';
import { A11yModule } from '@angular/cdk/a11y';
import { SafeHtmlPipe } from 'src/app/shared/safe-html-pipe/safe-html.pipe';


@NgModule({
  declarations: [SafeHtmlPipe],
  imports: [
    CommonModule,
    A11yModule,
    MaterialModule
  ],
  exports: [
    A11yModule,
    MaterialModule,
    SafeHtmlPipe
  ]
})
export class SharedModule {
  constructor(
    private domSanitizer: DomSanitizer,
    private matIconRegistry: MatIconRegistry,
  ) {
    this.matIconRegistry.addSvgIcon(
      'ic_change_orientation',
      this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/img/ic_change_orientation.svg')
    ).addSvgIcon(
      'ic_arrow_circle',
      this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/img/ic_arrow_circle.svg')
    );
  }
}
